<template>
  <section class="partner">
    <div
      class="progressNum"
      v-if="step > 0"
    >
      <ul>
        <li :class="{active:step==1}"></li>
        <span class="step_divider"></span>
        <li :class="{active:step==2}"></li>
      </ul>
    </div>

    <div
      class="step"
      v-if="step == 0"
    >
      <h2 class="center">ARE YOU AN INDIVIDUAL OR A COMPANY?</h2>
      <a
        class="button btn-step0"
        @click="$bus.$emit('SelectLegalType', 'individual')"
      >{{$t('individual').tUpper()}}</a>
      <a
        class="button btn-step0"
        @click="$bus.$emit('SelectLegalType', 'company')"
      >{{$t('company').tUpper()}}</a>
    </div>

    <!--
 d888                    8888888 888b    888 8888888b. 8888888 888     888 8888888 8888888b.  888     888       d8888 888
d8888                      888   8888b   888 888  "Y88b  888   888     888   888   888  "Y88b 888     888      d88888 888
  888                      888   88888b  888 888    888  888   888     888   888   888    888 888     888     d88P888 888
  888                      888   888Y88b 888 888    888  888   Y88b   d88P   888   888    888 888     888    d88P 888 888
  888                      888   888 Y88b888 888    888  888    Y88b d88P    888   888    888 888     888   d88P  888 888
  888        888888        888   888  Y88888 888    888  888     Y88o88P     888   888    888 888     888  d88P   888 888
  888                      888   888   Y8888 888  .d88P  888      Y888P      888   888  .d88P Y88b. .d88P d8888888888 888
8888888                  8888888 888    Y888 8888888P" 8888888     Y8P     8888888 8888888P"   "Y88888P" d88P     888 88888888
    -->

    <div
      class="step"
      v-if="step == 1 && legalType == 'individual'"
    >
      <h2>{{$t('personal_information').tUpper()}}</h2>
      <div class="columns">
        <div class="column is-2">
          <label
            class="label"
            for="title"
          >{{translations.text.title}}</label>
          <p class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('title') }"
                :data-vv-as="translations.text.title"
                name="title"
                v-model="body.title"
              >
                <option value></option>
                <option
                  v-for="(item, index) in titles"
                  :value="index"
                  :key="index"
                >{{item}}</option>
              </select>
            </span>
            <span
              v-show="errors.has('title')"
              class="help is-danger"
            >{{ errors.first('title') }}</span>
          </p>
        </div>
        <div class="column">
          <label
            class="label"
            for="firstname"
          >{{translations.text.firstname}}</label>
          <p class="control">
            <input
              v-validate="'required|alpha_spaces'"
              :class="{'input': true, 'is-danger': errors.has('firstname') }"
              name="firstname"
              type="text"
              :data-vv-as="translations.text.firstname"
              :placeholder="translations.text.firstname"
              v-model="body.firstname"
            />
            <span
              v-show="errors.has('firstname')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('firstname') }}</span>
          </p>
        </div>
        <div class="column">
          <label
            class="label"
            for="lastname"
          >{{translations.text.lastname}}</label>
          <p class="control">
            <input
              v-validate="'required|alpha_spaces'"
              :class="{'input': true, 'is-danger': errors.has('lastname') }"
              name="lastname"
              type="text"
              :data-vv-as="translations.text.lastname"
              :placeholder="translations.text.lastname"
              v-model="body.lastname"
            />
            <span
              v-show="errors.has('lastname')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('lastname') }}</span>
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="email"
          >{{translations.text.email}}</label>
          <p class="control">
            <input
              v-validate="'required|email|email-available'"
              :class="{'input': true, 'is-danger': errors.has('email') }"
              name="email"
              type="text"
              :data-vv-as="translations.text.email"
              :placeholder="translations.text.email"
              v-model="body.email"
            />
            <span
              v-show="errors.has('email')"
              class="help is-danger"
            >{{ errors.first('email') }}</span>
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="country"
          >{{translations.text.country}}</label>
          <p class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('country') }"
                :data-vv-as="translations.text.country"
                name="country"
                v-model="body.country"
                @change="checkIfIsEuropeanCountry"
              >
                <option value=""></option>
                <option
                  v-for="(item, index) in filteredCountries"
                  :value="index"
                  :key="index"
                >{{item.name}}</option>
              </select>
            </span>
            <span
              v-show="errors.has('country')"
              class="help is-danger"
            >{{ errors.first('country') }}</span>
          </p>
        </div>
        <div class="columns column">
          <!-- <div class="column is-one-quarters">
					<label class="label" for="dialCode">{{$t('dial_code').tUpper()}}</label>
					<p class="control">
						<img class="flag" :class="'flag-'+body.country.toLowerCase()">
						<input v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('dialCode') }" name="dialCode" class="dialCode" type="text" :data-vv-as="$t('dial_code')" :placeholder="$t('dial_code')" v-model="body.dialCode">
						<span v-show="errors.has('dialCode')" class="help is-danger">{{ errors.first('dialCode') }}</span>
					</p>
          </div>-->
          <div class="column">
            <label
              class="label"
              for="phone"
            >{{translations.text.phone}}</label>
            <div class="control relative">
              <div class="dialcodeBox">{{body.country!=''?body.dialCode:''}}</div>
              <input
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('phone'),'push-left':body.country!=''  }"
                name="phone"
                type="text"
                :data-vv-as="translations.text.phone"
                :placeholder="translations.text.phone"
                v-model="body.phone"
              />
              <span
                v-show="errors.has('phone')"
                class="help is-danger"
              >{{ errors.first('phone') }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- <a
        class="button is-dark is-pulled-left previous"
        @click="$bus.$emit('PreviousStep', $event)"
      >
        <span>{{$t("previous")}}</span>
      </a> -->
      <a
        class="button is-primary is-pulled-right next"
        @click="nextStep"
      >
        <span>NEXT</span>
      </a>
    </div>

    <!--
 d888                     .d8888b.   .d88888b.  888b     d888 8888888b.     d8888 888b    888 Y88b   d88P
d8888                    d88P  Y88b d88P" "Y88b 8888b   d8888 888   Y88b   d88888 8888b   888  Y88b d88P
  888                    888    888 888     888 88888b.d88888 888    888  d88P888 88888b  888   Y88o88P
  888                    888        888     888 888Y88888P888 888   d88P d88P 888 888Y88b 888    Y888P
  888                    888        888     888 888 Y888P 888 8888888P" d88P  888 888 Y88b888     888
  888        888888      888    888 888     888 888  Y8P  888 888      d88P   888 888  Y88888     888
  888                    Y88b  d88P Y88b. .d88P 888   "   888 888     d8888888888 888   Y8888     888
8888888                   "Y8888P"   "Y88888P"  888       888 888    d88P     888 888    Y888     888
    -->

    <div
      class="step"
      v-if="step == 1 && legalType == 'company'"
    >
      <h2>{{$t('company_information').tUpper()}}</h2>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="company_name"
          >{{translations.text.company_name}}</label>
          <p class="control">
            <input
              v-validate="'required'"
              :class="{'input': true, 'is-danger': errors.has('company_name') }"
              name="company_name"
              type="text"
              :data-vv-as="translations.text.company_name"
              :placeholder="translations.text.company_name"
              v-model="body.company_name"
            />
            <span
              v-show="errors.has('company_name')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('company_name') }}</span>
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="website"
          >{{translations.text.company_website}}</label>
          <p class="control">
            <input
              v-validate="''"
              :class="{'input': true, 'is-danger': errors.has('website') }"
              name="website"
              type="text"
              :data-vv-as="translations.text.company_website"
              :placeholder="translations.text.website"
              v-model="body.website"
            />
            <span
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              v-show="errors.has('website')"
              class="help is-danger"
            >{{ errors.first('website') }}</span>
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="skype_id"
          >{{translations.text.skype_id}}</label>
          <p class="control">
            <input
              v-validate="''"
              :class="{'input': true, 'is-danger': errors.has('skype_id') }"
              name="skype_id"
              type="text"
              :data-vv-as="translations.text.skype_id"
              :placeholder="translations.text.skype_id"
              v-model="body.skype_id"
            />
            <span
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              v-show="errors.has('skype_id')"
              class="help is-danger"
            >{{ errors.first('skype_id') }}</span>
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="country"
          >{{translations.text.country}}</label>
          <p class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('country') }"
                :data-vv-as="translations.text.country"
                name="country"
                v-model="body.country"
                @change="checkIfIsEuropeanCountry"
              >
                <option value=""></option>
                <option
                  v-for="(item, index) in filteredCountries"
                  :value="index"
                  :key="index"
                >{{item.name}}</option>
              </select>
            </span>
            <span
              v-show="errors.has('country')"
              class="help is-danger"
            >{{ errors.first('country') }}</span>
          </p>
        </div>
        <div class="columns column">
          <!-- <div class="column is-one-quarters">
					<label class="label" for="dialCode">{{$t('dial_code').tUpper()}}</label>
					<p class="control">
						<img class="flag" :class="'flag-'+body.country.toLowerCase()">
						<input v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('dialCode') }" name="dialCode" class="dialCode" type="text" :data-vv-as="$t('dial_code')" :placeholder="$t('dial_code')" v-model="body.dialCode">
						<span v-show="errors.has('dialCode')" class="help is-danger">{{ errors.first('dialCode') }}</span>
					</p>
          </div>-->
          <div class="column">
            <label
              class="label"
              for="phone"
            >{{translations.text.phone}}</label>
            <div class="control relative">
              <div class="dialcodeBox">{{body.country!=''?body.dialCode:''}}</div>
              <input
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('phone'),'push-left':body.country!='' }"
                name="phone"
                type="text"
                :data-vv-as="translations.text.phone"
                :placeholder="translations.text.phone"
                v-model="body.phone"
              />
              <span
                v-show="errors.has('phone')"
                class="help is-danger"
              >{{ errors.first('phone') }}</span>
            </div>
          </div>
        </div>
      </div>

      <h2 :class="{'has-text-right': Language == 'fa' || Language == 'ar'}">{{$t('company_registration_information').tUpper()}}</h2>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="dob"
          >{{translations.text.date_of_registration}}</label>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <label
            class="label is-small"
            for="dob_day"
          >{{translations.text.day}}</label>
          <p class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('dob_day') }"
                :data-vv-as="translations.text.day"
                name="dob_day"
                v-model="body.dob.day"
              >
                <option value></option>
                <option
                  v-for="day in monthDayIndexes"
                  :value="day"
                  :key="day"
                >{{day}}</option>
              </select>
            </span>
            <span
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              v-show="errors.has('dob_day')"
              class="help is-danger"
            >{{ errors.first('dob_day') }}</span>
          </p>
        </div>
        <div class="column">
          <label
            class="label is-small"
            for="dob_month"
          >{{translations.text.month}}</label>
          <p class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('dob_month') }"
                :data-vv-as="translations.text.month"
                name="dob_month"
                v-model="body.dob.month"
              >
                <option value></option>
                <option
                  v-for="(month, index) in translations.months"
                  :value="index"
                  :key="index"
                >{{month}}</option>
              </select>
            </span>
            <span
              v-show="errors.has('dob_month')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('dob_month') }}</span>
          </p>
        </div>
        <div class="column">
          <label
            class="label is-small"
            for="dob_year"
          >{{translations.text.year}}</label>
          <p class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('dob_year') }"
                :data-vv-as="translations.text.year"
                name="dob_year"
                v-model="body.dob.year"
              >
                <option value></option>
                <option
                  v-for="year in years"
                  :value="year"
                  :key="year"
                >{{year}}</option>
              </select>
            </span>
            <span
              v-show="errors.has('dob_year')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('dob_year') }}</span>
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="address"
          >{{translations.text.address}}</label>
          <p class="control">
            <input
              v-validate="'required'"
              :class="{'input': true, 'is-danger': errors.has('address') }"
              name="address"
              type="text"
              :data-vv-as="translations.text.address"
              :placeholder="translations.text.address"
              v-model="body.address"
            />
            <span
              v-show="errors.has('address')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('address') }}</span>
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="address2"
          >{{translations.text.address2}}</label>
          <p class="control">
            <input
              v-validate="''"
              :class="{'input': true, 'is-danger': errors.has('address2') }"
              name="address2"
              type="text"
              :data-vv-as="translations.text.address2"
              :placeholder="translations.text.address2"
              v-model="body.address2"
            />
            <span
              v-show="errors.has('address2')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('address2') }}</span>
          </p>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="post_code"
          >{{translations.text.post_code}}</label>
          <p class="control">
            <input
              v-validate="'required'"
              :class="{'input': true, 'is-danger': errors.has('post_code') }"
              name="post_code"
              type="text"
              :data-vv-as="translations.text.post_code"
              :placeholder="translations.text.post_code"
              v-model="body.post_code"
            />
            <span
              v-show="errors.has('post_code')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('post_code') }}</span>
          </p>
        </div>
        <div class="column">
          <label
            class="label"
            for="city"
          >{{translations.text.city}}</label>
          <p class="control">
            <input
              v-validate="'required'"
              :class="{'input': true, 'is-danger': errors.has('city') }"
              name="city"
              type="text"
              :data-vv-as="translations.text.city"
              :placeholder="translations.text.city"
              v-model="body.city"
            />
            <span
              v-show="errors.has('city')"
              class="help is-danger"
            >{{ errors.first('city') }}</span>
          </p>
        </div>
        <div class="column">
          <label
            class="label"
            for="state_province"
          >{{translations.text.state_province}}</label>
          <p class="control">
            <input
              v-validate="'required'"
              :class="{'input': true, 'is-danger': errors.has('state_province') }"
              name="state_province"
              type="text"
              :data-vv-as="translations.text.state_province"
              :placeholder="translations.text.state_province"
              v-model="body.state_province"
            />
            <span
              v-show="errors.has('state_province')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('state_province') }}</span>
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            for="year_moved_to_address"
          >{{translations.text.year_moved_to_address}}</label>
          <p class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('year_moved_to_address') }"
                :data-vv-as="translations.text.year_moved_to_address"
                name="year_moved_to_address"
                v-model="body.year_moved_to_address"
              >
                <option value></option>
                <option
                  v-for="year in years"
                  :value="year"
                  :key="year"
                >{{year}}</option>
              </select>
            </span>
            <span
              v-show="errors.has('year_moved_to_address')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('year_moved_to_address') }}</span>
          </p>
        </div>
      </div>

      <h2 :class="{'has-text-right': Language == 'fa' || Language == 'ar'}">{{$t('login_information').tUpper()}}</h2>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="email"
          >{{translations.text.email}}</label>
          <p class="control">
            <input
              v-validate="'required|email|email-available'"
              :class="{'input': true, 'is-danger': errors.has('email') }"
              name="email"
              type="text"
              :data-vv-as="translations.text.email"
              :placeholder="translations.text.email"
              v-model="body.email"
            />
            <span
              v-show="errors.has('email')"
              class="help is-danger"
            >{{ errors.first('email') }}</span>
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="password"
          >{{translations.text.password}}</label>
          <p class="control">
            <input
              v-validate="'required|strong-password|confirmed:confirm_password'"
              :class="{'input': true, 'is-danger': errors.has('password') }"
              name="password"
              type="password"
              :data-vv-as="translations.text.password"
              :placeholder="translations.text.password"
              v-model="body.password"
            />
            <span
              v-show="errors.has('password')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('password') }}</span>
          </p>
        </div>
        <div class="column">
          <label
            class="label"
            for="confirm_password"
          >{{translations.text.confirm_password}}</label>
          <p class="control">
            <input
              v-validate="'required'"
              :class="{'input': true, 'is-danger': errors.has('confirm_password') }"
              name="confirm_password"
              ref="confirm_password"
              type="password"
              :data-vv-as="translations.text.confirm_password"
              :placeholder="translations.text.confirm_password"
              v-model="body.confirm_password"
            />
            <span
              v-show="errors.has('confirm_password')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('confirm_password') }}</span>
          </p>
        </div>
      </div>

      <a
        class="button is-dark is-pulled-left previous"
        @click="$bus.$emit('PreviousStep', $event)"
      >
        <span>{{$t("previous")}}</span>
      </a>
      <a
        class="button is-primary is-pulled-right next"
        @click="nextStep"
      >
        <span>NEXT</span>
      </a>
    </div>

    <!--
 .d8888b.                   8888888 888b    888 8888888b. 8888888 888     888 8888888 8888888b.  888     888       d8888 888
d88P  Y88b                    888   8888b   888 888  "Y88b  888   888     888   888   888  "Y88b 888     888      d88888 888
       888                    888   88888b  888 888    888  888   888     888   888   888    888 888     888     d88P888 888
     .d88P                    888   888Y88b 888 888    888  888   Y88b   d88P   888   888    888 888     888    d88P 888 888
 .od888P"                     888   888 Y88b888 888    888  888    Y88b d88P    888   888    888 888     888   d88P  888 888
d88P"           888888        888   888  Y88888 888    888  888     Y88o88P     888   888    888 888     888  d88P   888 888
888"                          888   888   Y8888 888  .d88P  888      Y888P      888   888  .d88P Y88b. .d88P d8888888888 888
888888888                   8888888 888    Y888 8888888P" 8888888     Y8P     8888888 8888888P"   "Y88888P" d88P     888 88888888
    -->

    <div
      class="step"
      v-if="step == 2 && legalType == 'individual'"
    >
      <h2>{{$t('personal_information').tUpper()}}</h2>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="dob"
          >{{translations.text.date_of_birth}}</label>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <label
            class="label is-small"
            for="dob_day"
          >{{translations.text.day}}</label>
          <div class="control">
            <div class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('dob_day') }"
                :data-vv-as="translations.text.day"
                name="dob_day"
                v-model="body.dob.day"
              >
                <option value></option>
                <option
                  v-for="day in monthDayIndexes"
                  :value="day"
                  :key="day"
                >{{day}}</option>
              </select>
            </div>
            <span
              v-show="errors.has('dob_day')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('dob_day') }}</span>
          </div>
        </div>
        <div class="column">
          <label
            class="label is-small"
            for="dob_month"
          >{{translations.text.month}}</label>
          <div class="control">
            <div class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('dob_month') }"
                :data-vv-as="translations.text.month"
                name="dob_month"
                v-model="body.dob.month"
              >
                <option value></option>
                <option
                  v-for="(month, index) in translations.months"
                  :value="index"
                  :key="index"
                >{{month}}</option>
              </select>
            </div>
            <span
              v-show="errors.has('dob_month')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('dob_month') }}</span>
          </div>
        </div>
        <div class="column">
          <label
            class="label is-small"
            for="dob_year"
          >{{translations.text.year}}</label>
          <div class="control">
            <div class="select is-fullwidth">
              <select
                v-validate="{ required: true, 'is-over-18': body.dob.day + '-' + body.dob.month + '-' + body.dob.year }"
                :class="{'input': true, 'is-danger': errors.has('dob_year') }"
                :data-vv-as="translations.text.year"
                name="dob_year"
                v-model="body.dob.year"
              >
                <option value></option>
                <option
                  v-for="year in years"
                  :value="year"
                  :key="year"
                >{{year}}</option>
              </select>
            </div>
            <span
              v-show="errors.has('dob_year')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('dob_year') }}</span>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="ib_main_target_region"
          >{{translations.text.target_geo_location}}</label>
          <p class="control">
            <input
              v-validate="'required'"
              :class="{'input': true, 'is-danger': errors.has('ib_main_target_region') }"
              name="ib_main_target_region"
              type="text"
              :data-vv-as="translations.text.target_geo_location"
              :placeholder="translations.text.target_geo_location"
              v-model="body.ib_main_target_region"
            />
            <span
              v-show="errors.has('ib_main_target_region')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('ib_main_target_region') }}</span>
          </p>
        </div>
      </div>
      <div class="columns">
        <!-- <div class="column">
				<label class="label" for="nationality">{{translations.text.nationality}}</label>
				<p class="control">
					<span class="select is-fullwidth">
						<select v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('nationality') }" :data-vv-as="translations.text.nationality" name="nationality" v-model="body.nationality">
							<option value=""></option>
							<option v-for="item in nationalities" :value="item" :key="item">{{item}}</option>
						</select>
					</span>
					<span v-show="errors.has('nationality')" class="help is-danger">{{ errors.first('nationality') }}</span>
				</p>
        </div>-->
        <div class="column">
          <label
            class="label"
            for="gender"
          >{{translations.text.gender}}</label>
          <p class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('gender') }"
                :data-vv-as="translations.text.gender"
                name="gender"
                v-model="body.gender"
              >
                <option value></option>
                <option
                  v-for="(item, index) in translations.genders"
                  :value="index"
                  :key="index"
                >{{item}}</option>
              </select>
            </span>
            <span
              v-show="errors.has('gender')"
              class="help is-danger"
            >{{ errors.first('gender') }}</span>
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="address"
          >{{translations.text.address}}</label>
          <p class="control">
            <input
              v-validate="'required'"
              :class="{'input': true, 'is-danger': errors.has('address') }"
              name="address"
              type="text"
              :data-vv-as="translations.text.address"
              :placeholder="translations.text.address"
              v-model="body.address"
            />
            <span
              v-show="errors.has('address')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('address') }}</span>
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="address2"
          >{{translations.text.address2}}</label>
          <p class="control">
            <input
              v-validate="''"
              :class="{'input': true, 'is-danger': errors.has('address2') }"
              name="address2"
              type="text"
              :data-vv-as="translations.text.address2"
              :placeholder="translations.text.address2"
              v-model="body.address2"
            />
            <span
              v-show="errors.has('address2')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('address2') }}</span>
          </p>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="post_code"
          >{{translations.text.post_code}}</label>
          <p class="control">
            <input
              v-validate="'required'"
              :class="{'input': true, 'is-danger': errors.has('post_code') }"
              name="post_code"
              type="text"
              :data-vv-as="translations.text.post_code"
              :placeholder="translations.text.post_code"
              v-model="body.post_code"
            />
            <span
              v-show="errors.has('post_code')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('post_code') }}</span>
          </p>
        </div>
        <div class="column">
          <label
            class="label"
            for="city"
          >{{translations.text.city}}</label>
          <p class="control">
            <input
              v-validate="'required'"
              :class="{'input': true, 'is-danger': errors.has('city') }"
              name="city"
              type="text"
              :data-vv-as="translations.text.city"
              :placeholder="translations.text.city"
              v-model="body.city"
            />
            <span
              v-show="errors.has('city')"
              class="help is-danger"
            >{{ errors.first('city') }}</span>
          </p>
        </div>
        <div class="column">
          <label
            class="label"
            for="state_province"
          >{{translations.text.state_province}}</label>
          <p class="control">
            <input
              v-validate="'required'"
              :class="{'input': true, 'is-danger': errors.has('state_province') }"
              name="state_province"
              type="text"
              :data-vv-as="translations.text.state_province"
              :placeholder="translations.text.state_province"
              v-model="body.state_province"
            />
            <span
              v-show="errors.has('state_province')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('state_province') }}</span>
          </p>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="year_moved_to_address"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
          >{{translations.text.year_moved_to_address}}</label>
          <p class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('year_moved_to_address') }"
                :data-vv-as="translations.text.year_moved_to_address"
                name="year_moved_to_address"
                v-model="body.year_moved_to_address"
              >
                <option value></option>
                <option
                  v-for="year in years"
                  :value="year"
                  :key="year"
                >{{year}}</option>
              </select>
            </span>
            <span
              v-show="errors.has('year_moved_to_address')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('year_moved_to_address') }}</span>
          </p>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="website"
          >{{translations.text.website}}</label>
          <p class="control">
            <input
              v-validate="''"
              :class="{'input': true, 'is-danger': errors.has('website') }"
              name="website"
              type="text"
              :data-vv-as="translations.text.website"
              :placeholder="translations.text.website"
              v-model="body.website"
            />
            <span
              v-show="errors.has('website')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('website') }}</span>
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="skype_id"
          >{{translations.text.skype_id}}</label>
          <p class="control">
            <input
              v-validate="''"
              :class="{'input': true, 'is-danger': errors.has('skype_id') }"
              name="skype_id"
              type="text"
              :data-vv-as="translations.text.skype_id"
              :placeholder="translations.text.skype_id"
              v-model="body.skype_id"
            />
            <span
              v-show="errors.has('skype_id')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('skype_id') }}</span>
          </p>
        </div>
      </div>

      <!-- <h2>{{$t('login_information').tUpper()}}</h2> -->
      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="password"
          >{{translations.text.password}}</label>
          <p class="control">
            <input
              v-validate="'required|strong-password|confirmed:confirm_password'"
              :class="{'input': true, 'is-danger': errors.has('password') }"
              name="password"
              type="password"
              :data-vv-as="translations.text.password"
              :placeholder="translations.text.password"
              v-model="body.password"
            />
            <span
              v-show="errors.has('password')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('password') }}</span>
          </p>
        </div>
        <div class="column">
          <label
            class="label"
            for="confirm_password"
          >{{translations.text.confirm_password}}</label>
          <p class="control">
            <input
              v-validate="'required'"
              :class="{'input': true, 'is-danger': errors.has('confirm_password') }"
              name="confirm_password"
              ref="confirm_password"
              type="password"
              :data-vv-as="translations.text.confirm_password"
              :placeholder="translations.text.confirm_password"
              v-model="body.confirm_password"
            />
            <span
              v-show="errors.has('confirm_password')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('confirm_password') }}</span>
          </p>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <p
            class="control"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
          >
            <label class="checkbox">
              <input
                v-validate="''"
                class="agreements"
                :class="{'is-danger': errors.has('include_account_in_bonus_program') }"
                name="tos_with_link"
                type="checkbox"
                :data-vv-as="translations.text.tos_with_link"
                v-model="body.tos_with_link"
              />
              <span class="checkmark"></span>
              <span v-html="translations.text.tos_with_link"></span>
            </label>
            <span
              v-show="errors.has('tos_with_link')"
              class="help is-danger"
            >{{ errors.first('tos_with_link') }}</span>
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <p class="control">
            <label class="checkbox">
              <input
                class="agreements"
                :class="{ 'is-danger': errors.has('agree_terms_marketing') }"
                name="agree_terms_marketing"
                type="checkbox"
                :data-vv-as="translations.text.agree_terms_marketing"
                v-model="body.agree_terms_marketing"
              />
              <span class="checkmark"></span>
              <!-- <span>{{ $t('agree_terms_marketing')}}</span> -->
              <span v-html="translations.text.agree_terms_marketing"></span>
            </label>
          </p>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <p
            class="control privacy_data_text"
            v-html="translations.text.data_policy_text"
          >
          </p>
        </div>
      </div>

      <a
        class="button is-dark is-pulled-left previous"
        @click="$bus.$emit('PreviousStep', $event)"
      >
        <span>{{$t("previous")}}</span>
      </a>
      <a
        class="button is-success is-pulled-right is-medium next"
        :class="[isDisabled? 'disabledButton':'']"
        @click="validateCaptcha"
        :disabled="isDisabled"
      >
        <span class="icon is-small">
          <i class="fa fa-check"></i>
        </span>
        <span>{{$t("complete")}}</span>
      </a>
    </div>

    <!--
 .d8888b.                    .d8888b.   .d88888b.  888b     d888 8888888b.     d8888 888b    888 Y88b   d88P
d88P  Y88b                  d88P  Y88b d88P" "Y88b 8888b   d8888 888   Y88b   d88888 8888b   888  Y88b d88P
       888                  888    888 888     888 88888b.d88888 888    888  d88P888 88888b  888   Y88o88P
     .d88P                  888        888     888 888Y88888P888 888   d88P d88P 888 888Y88b 888    Y888P
 .od888P"                   888        888     888 888 Y888P 888 8888888P" d88P  888 888 Y88b888     888
d88P"           888888      888    888 888     888 888  Y8P  888 888      d88P   888 888  Y88888     888
888"                        Y88b  d88P Y88b. .d88P 888   "   888 888     d8888888888 888   Y8888     888
888888888                    "Y8888P"   "Y88888P"  888       888 888    d88P     888 888    Y888     888
    -->

    <div
      class="step"
      v-if="step == 2 && legalType == 'company'"
    >
      <h2>{{$t('company_shareholders_directors').tUpper()}}</h2>

      <div class="columns">
        <div class="column">
          <label
            class="label"
            for="ib_main_target_region"
          >{{translations.text.target_geo_location}}</label>
          <p class="control">
            <input
              v-validate="'required'"
              :class="{'input': true, 'is-danger': errors.has('ib_main_target_region') }"
              name="ib_main_target_region"
              type="text"
              :data-vv-as="translations.text.target_geo_location"
              :placeholder="translations.text.target_geo_location"
              v-model="body.ib_main_target_region"
            />
            <span
              v-show="errors.has('ib_main_target_region')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('ib_main_target_region') }}</span>
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <label
            class="label is-small"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            for="numberOfShareholders"
          >{{translations.text.number_of_shareholders}}</label>
          <p class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('numberOfShareholders') }"
                :data-vv-as="translations.text.number_of_shareholders"
                name="numberOfShareholders"
                v-model="numberOfShareholders"
              >
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
              </select>
            </span>
            <span
              v-show="errors.has('numberOfShareholders')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('numberOfShareholders') }}</span>
          </p>
        </div>
        <div class="column">
          <label
            class="label is-small"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            for="numberOfDirectors"
          >{{translations.text.number_of_directors}}</label>
          <p class="control">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('numberOfDirectors') }"
                :data-vv-as="translations.text.number_of_directors"
                name="numberOfDirectors"
                v-model="numberOfDirectors"
              >
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
              </select>
            </span>
            <span
              v-show="errors.has('numberOfDirectors')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('numberOfDirectors') }}</span>
          </p>
        </div>
      </div>
      <!--
		         888                               888               888      888
		         888                               888               888      888
		         888                               888               888      888
		.d8888b  88888b.   8888b.  888d888 .d88b.  88888b.   .d88b.  888  .d88888  .d88b.  888d888 .d8888b
		88K      888 "88b     "88b 888P"  d8P  Y8b 888 "88b d88""88b 888 d88" 888 d8P  Y8b 888P"   88K
		"Y8888b. 888  888 .d888888 888    88888888 888  888 888  888 888 888  888 88888888 888     "Y8888b.
		     X88 888  888 888  888 888    Y8b.     888  888 Y88..88P 888 Y88b 888 Y8b.     888          X88
		 88888P' 888  888 "Y888888 888     "Y8888  888  888  "Y88P"  888  "Y88888  "Y8888  888      88888P'
      -->
      <div
        v-for="(person, index) in body.shareholders"
        :key="'share-'+index"
        class="shareholders-directors"
      >
        <h2>{{$t('shareholder').tUpper()}} - {{index+1}}</h2>
        <div class="columns">
          <div class="column">
            <label
              class="label"
              for="firstname"
            >{{translations.text.firstname}}</label>
            <p class="control">
              <input
                v-validate="'required|alpha_spaces'"
                :class="{'input': true, 'is-danger': errors.has('sh-firstname_'+index) }"
                :name="'sh-firstname_'+index"
                type="text"
                :data-vv-as="translations.text.firstname"
                :placeholder="translations.text.firstname"
                v-model="person.firstname"
              />
              <span
                v-show="errors.has('sh-firstname_'+index)"
                class="help is-danger"
              >{{ errors.first('sh-firstname_'+index) }}</span>
            </p>
          </div>
          <div class="column">
            <label
              class="label"
              for="lastname"
            >{{translations.text.lastname}}</label>
            <p class="control">
              <input
                v-validate="'required|alpha_spaces'"
                :class="{'input': true, 'is-danger': errors.has('sh-lastname_'+index) }"
                :name="'sh-lastname_'+index"
                type="text"
                :data-vv-as="translations.text.lastname"
                :placeholder="translations.text.lastname"
                v-model="person.lastname"
              />
              <span
                v-show="errors.has('sh-lastname_'+index)"
                class="help is-danger"
              >{{ errors.first('sh-lastname_'+index) }}</span>
            </p>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <label
              class="label"
              for="dob"
            >{{translations.text.date_of_birth}}</label>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <label
              class="label is-small"
              for="dob_day"
            >{{translations.text.day}}</label>
            <p class="control">
              <span class="select is-fullwidth">
                <select
                  v-validate="'required'"
                  :class="{'input': true, 'is-danger': errors.has('sh-dob_day_'+index) }"
                  :data-vv-as="translations.text.day"
                  :name="'sh-dob_day_'+index"
                  v-model="person.dob.day"
                >
                  <option value></option>
                  <option
                    v-for="day in monthDayIndexes"
                    :value="day"
                    :key="day"
                  >{{day}}</option>
                </select>
              </span>
              <span
                v-show="errors.has('sh-dob_day_'+index)"
                class="help is-danger"
              >{{ errors.first('sh-dob_day_'+index) }}</span>
            </p>
          </div>
          <div class="column">
            <label
              class="label is-small"
              for="dob_month"
            >{{translations.text.month}}</label>
            <p class="control">
              <span class="select is-fullwidth">
                <select
                  v-validate="'required'"
                  :class="{'input': true, 'is-danger': errors.has('sh-dob_month_'+index) }"
                  :data-vv-as="translations.text.month"
                  :name="'sh-dob_month_'+index"
                  v-model="person.dob.month"
                >
                  <option value></option>
                  <option
                    v-for="(month, index) in translations.months"
                    :value="index"
                    :key="index"
                  >{{month}}</option>
                </select>
              </span>
              <span
                v-show="errors.has('sh-dob_month_'+index)"
                class="help is-danger"
              >{{ errors.first('sh-dob_month_'+index) }}</span>
            </p>
          </div>
          <div class="column">
            <label
              class="label is-small"
              for="dob_year"
            >{{translations.text.year}}</label>
            <p class="control">
              <span class="select is-fullwidth">
                <select
                  v-validate="{ required: true, 'is-over-18': person.dob.day + '-' + person.dob.month + '-' + person.dob.year }"
                  :class="{'input': true, 'is-danger': errors.has('sh-dob_year_'+index) }"
                  :data-vv-as="translations.text.year"
                  :name="'sh-dob_year_'+index"
                  v-model="person.dob.year"
                >
                  <option value></option>
                  <option
                    v-for="year in years"
                    :value="year"
                    :key="year"
                  >{{year}}</option>
                </select>
              </span>
              <span
                v-show="errors.has('sh-dob_year_'+index)"
                class="help is-danger"
              >{{ errors.first('sh-dob_year_'+index) }}</span>
            </p>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <label
              class="label"
              for="address"
            >{{translations.text.address}}</label>
            <p class="control">
              <input
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('sh-address_'+index) }"
                :name="'sh-address_'+index"
                type="text"
                :data-vv-as="translations.text.address"
                :placeholder="translations.text.address"
                v-model="person.address"
              />
              <span
                v-show="errors.has('sh-address_'+index)"
                class="help is-danger"
              >{{ errors.first('sh-address_'+index) }}</span>
            </p>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <label
              class="label"
              for="address2"
            >{{translations.text.address2}}</label>
            <p class="control">
              <input
                v-validate="''"
                :class="{'input': true, 'is-danger': errors.has('sh-address2_'+index) }"
                :name="'sh-address2_'+index"
                type="text"
                :data-vv-as="translations.text.address2"
                :placeholder="translations.text.address2"
                v-model="person.address2"
              />
              <span
                v-show="errors.has('sh-address2_'+index)"
                class="help is-danger"
              >{{ errors.first('sh-address2_'+index) }}</span>
            </p>
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <label
              class="label"
              for="post_code"
            >{{translations.text.post_code}}</label>
            <p class="control">
              <input
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('sh-post_code_'+index) }"
                :name="'sh-post_code_'+index"
                type="text"
                :data-vv-as="translations.text.post_code"
                :placeholder="translations.text.post_code"
                v-model="person.post_code"
              />
              <span
                v-show="errors.has('sh-post_code_'+index)"
                class="help is-danger"
              >{{ errors.first('sh-post_code_'+index) }}</span>
            </p>
          </div>
          <div class="column">
            <label
              class="label"
              for="city"
            >{{translations.text.city}}</label>
            <p class="control">
              <input
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('sh-city_'+index) }"
                :name="'sh-city_'+index"
                type="text"
                :data-vv-as="translations.text.city"
                :placeholder="translations.text.city"
                v-model="person.city"
              />
              <span
                v-show="errors.has('sh-city_'+index)"
                class="help is-danger"
              >{{ errors.first('sh-city_'+index) }}</span>
            </p>
          </div>
          <div class="column">
            <label
              class="label"
              for="state_province"
            >{{translations.text.state_province}}</label>
            <p class="control">
              <input
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('sh-state_province_'+index) }"
                :name="'sh-state_province_'+index"
                type="text"
                :data-vv-as="translations.text.state_province"
                :placeholder="translations.text.state_province"
                v-model="person.state_province"
              />
              <span
                v-show="errors.has('sh-state_province_'+index)"
                class="help is-danger"
              >{{ errors.first('sh-state_province_'+index) }}</span>
            </p>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <label
              class="label"
              for="country"
            >{{translations.text.country}}</label>
            <p class="control">
              <span class="select is-fullwidth">
                <select
                  v-validate="'required'"
                  :class="{'input': true, 'is-danger': errors.has('sh-country_'+index) }"
                  :data-vv-as="translations.text.country"
                  :name="'sh-country_'+index"
                  v-model="person.country"
                >
                  <option value></option>
                  <option
                    v-for="(item, index) in filteredCountries"
                    :value="index"
                    :key="index"
                  >{{item.name}}</option>
                </select>
              </span>
              <span
                v-show="errors.has('sh-country_'+index)"
                class="help is-danger"
              >{{ errors.first('sh-country_'+index) }}</span>
            </p>
          </div>
          <div class="column">
            <label
              class="label"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              for="year_moved_to_address"
            >{{translations.text.year_moved_to_address}}</label>
            <p class="control">
              <span class="select is-fullwidth">
                <select
                  v-validate="'required'"
                  :class="{'input': true, 'is-danger': errors.has('sh-year_moved_to_address_'+index) }"
                  :data-vv-as="translations.text.year_moved_to_address"
                  :name="'sh-year_moved_to_address_'+index"
                  v-model="person.year_moved_to_address"
                >
                  <option value></option>
                  <option
                    v-for="year in years"
                    :value="year"
                    :key="year"
                  >{{year}}</option>
                </select>
              </span>
              <span
                v-show="errors.has('sh-year_moved_to_address_'+index)"
                class="help is-danger"
              >{{ errors.first('sh-year_moved_to_address_'+index) }}</span>
            </p>
          </div>
        </div>
      </div>
      <!--
		     888 d8b                          888
		     888 Y8P                          888
		     888                              888
		 .d88888 888 888d888 .d88b.   .d8888b 888888 .d88b.  888d888 .d8888b
		d88" 888 888 888P"  d8P  Y8b d88P"    888   d88""88b 888P"   88K
		888  888 888 888    88888888 888      888   888  888 888     "Y8888b.
		Y88b 888 888 888    Y8b.     Y88b.    Y88b. Y88..88P 888          X88
		 "Y88888 888 888     "Y8888   "Y8888P  "Y888 "Y88P"  888      88888P'
      -->
      <div
        v-for="(person, index) in body.directors"
        :key="'direct-'+index"
        class="shareholders-directors"
      >
        <h2>{{$t('director').tUpper()}} - {{index+1}}</h2>
        <div class="columns">
          <div class="column">
            <label
              class="label"
              for="firstname"
            >{{translations.text.firstname}}</label>
            <p class="control">
              <input
                v-validate="'required|alpha_spaces'"
                :class="{'input': true, 'is-danger': errors.has('dir-firstname_'+index) }"
                :name="'dir-firstname_'+index"
                type="text"
                :data-vv-as="translations.text.firstname"
                :placeholder="translations.text.firstname"
                v-model="person.firstname"
              />
              <span
                v-show="errors.has('dir-firstname_'+index)"
                class="help is-danger"
              >{{ errors.first('dir-firstname_'+index) }}</span>
            </p>
          </div>
          <div class="column">
            <label
              class="label"
              for="lastname"
            >{{translations.text.lastname}}</label>
            <p class="control">
              <input
                v-validate="'required|alpha_spaces'"
                :class="{'input': true, 'is-danger': errors.has('dir-lastname_'+index) }"
                :name="'dir-lastname_'+index"
                type="text"
                :data-vv-as="translations.text.lastname"
                :placeholder="translations.text.lastname"
                v-model="person.lastname"
              />
              <span
                v-show="errors.has('dir-lastname_'+index)"
                class="help is-danger"
              >{{ errors.first('dir-lastname_'+index) }}</span>
            </p>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <label
              class="label"
              for="dob"
            >{{translations.text.date_of_birth}}</label>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <label
              class="label is-small"
              for="dob_day"
            >{{translations.text.day}}</label>
            <p class="control">
              <span class="select is-fullwidth">
                <select
                  v-validate="'required'"
                  :class="{'input': true, 'is-danger': errors.has('dir-dob_day_'+index) }"
                  :data-vv-as="translations.text.day"
                  :name="'dir-dob_day_'+index"
                  v-model="person.dob.day"
                >
                  <option value></option>
                  <option
                    v-for="day in monthDayIndexes"
                    :value="day"
                    :key="day"
                  >{{day}}</option>
                </select>
              </span>
              <span
                v-show="errors.has('dir-dob_day_'+index)"
                class="help is-danger"
              >{{ errors.first('dir-dob_day_'+index) }}</span>
            </p>
          </div>
          <div class="column">
            <label
              class="label is-small"
              for="dob_month"
            >{{translations.text.month}}</label>
            <p class="control">
              <span class="select is-fullwidth">
                <select
                  v-validate="'required'"
                  :class="{'input': true, 'is-danger': errors.has('dir-dob_month_'+index) }"
                  :data-vv-as="translations.text.month"
                  :name="'dir-dob_month_'+index"
                  v-model="person.dob.month"
                >
                  <option value></option>
                  <option
                    v-for="(month, index) in translations.months"
                    :value="index"
                    :key="index"
                  >{{month}}</option>
                </select>
              </span>
              <span
                v-show="errors.has('dir-dob_month_'+index)"
                class="help is-danger"
              >{{ errors.first('dir-dob_month_'+index) }}</span>
            </p>
          </div>
          <div class="column">
            <label
              class="label is-small"
              for="dob_year"
            >{{translations.text.year}}</label>
            <p class="control">
              <span class="select is-fullwidth">
                <select
                  v-validate="{ required: true, 'is-over-18': person.dob.day + '-' + person.dob.month + '-' + person.dob.year }"
                  :class="{'input': true, 'is-danger': errors.has('dir-dob_year_'+index) }"
                  :data-vv-as="translations.text.year"
                  :name="'dir-dob_year_'+index"
                  v-model="person.dob.year"
                >
                  <option value></option>
                  <option
                    v-for="year in years"
                    :value="year"
                    :key="year"
                  >{{year}}</option>
                </select>
              </span>
              <span
                v-show="errors.has('dir-dob_year_'+index)"
                class="help is-danger"
              >{{ errors.first('dir-dob_year_'+index) }}</span>
            </p>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <label
              class="label"
              for="address"
            >{{translations.text.address}}</label>
            <p class="control">
              <input
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('dir-address_'+index) }"
                :name="'dir-address_'+index"
                type="text"
                :data-vv-as="translations.text.address"
                :placeholder="translations.text.address"
                v-model="person.address"
              />
              <span
                v-show="errors.has('dir-address_'+index)"
                class="help is-danger"
              >{{ errors.first('dir-address_'+index) }}</span>
            </p>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <label
              class="label"
              for="address2"
            >{{translations.text.address2}}</label>
            <p class="control">
              <input
                v-validate="''"
                :class="{'input': true, 'is-danger': errors.has('dir-address2_'+index) }"
                :name="'dir-address2_'+index"
                type="text"
                :data-vv-as="translations.text.address2"
                :placeholder="translations.text.address2"
                v-model="person.address2"
              />
              <span
                v-show="errors.has('dir-address2_'+index)"
                class="help is-danger"
              >{{ errors.first('dir-address2_'+index) }}</span>
            </p>
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <label
              class="label"
              for="post_code"
            >{{translations.text.post_code}}</label>
            <p class="control">
              <input
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('dir-post_code_'+index) }"
                :name="'dir-post_code_'+index"
                type="text"
                :data-vv-as="translations.text.post_code"
                :placeholder="translations.text.post_code"
                v-model="person.post_code"
              />
              <span
                v-show="errors.has('dir-post_code_'+index)"
                class="help is-danger"
              >{{ errors.first('dir-post_code_'+index) }}</span>
            </p>
          </div>
          <div class="column">
            <label
              class="label"
              for="city"
            >{{translations.text.city}}</label>
            <p class="control">
              <input
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('dir-city_'+index) }"
                :name="'dir-city_'+index"
                type="text"
                :data-vv-as="translations.text.city"
                :placeholder="translations.text.city"
                v-model="person.city"
              />
              <span
                v-show="errors.has('dir-city_'+index)"
                class="help is-danger"
              >{{ errors.first('dir-city_'+index) }}</span>
            </p>
          </div>
          <div class="column">
            <label
              class="label"
              for="state_province"
            >{{translations.text.state_province}}</label>
            <p class="control">
              <input
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('dir-state_province_'+index) }"
                :name="'dir-state_province_'+index"
                type="text"
                :data-vv-as="translations.text.state_province"
                :placeholder="translations.text.state_province"
                v-model="person.state_province"
              />
              <span
                v-show="errors.has('dir-state_province_'+index)"
                class="help is-danger"
              >{{ errors.first('dir-state_province_'+index) }}</span>
            </p>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <label
              class="label"
              for="country"
            >{{translations.text.country}}</label>
            <p class="control">
              <span class="select is-fullwidth">
                <select
                  v-validate="'required'"
                  :class="{'input': true, 'is-danger': errors.has('dir-country_'+index) }"
                  :data-vv-as="translations.text.country"
                  :name="'dir-country_'+index"
                  v-model="person.country"
                >
                  <option value></option>
                  <option
                    v-for="(item, index) in filteredCountries"
                    :value="index"
                    :key="index"
                  >{{item.name}}</option>
                </select>
              </span>
              <span
                v-show="errors.has('dir-country_'+index)"
                class="help is-danger"
              >{{ errors.first('dir-country_'+index) }}</span>
            </p>
          </div>
          <div class="column">
            <label
              class="label"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              for="year_moved_to_address"
            >{{translations.text.year_moved_to_address}}</label>
            <p class="control">
              <span class="select is-fullwidth">
                <select
                  v-validate="'required'"
                  :class="{'input': true, 'is-danger': errors.has('dir-year_moved_to_address_'+index) }"
                  :data-vv-as="translations.text.year_moved_to_address"
                  :name="'dir-year_moved_to_address_'+index"
                  v-model="person.year_moved_to_address"
                >
                  <option value></option>
                  <option
                    v-for="year in years"
                    :value="year"
                    :key="year"
                  >{{year}}</option>
                </select>
              </span>
              <span
                v-show="errors.has('dir-year_moved_to_address_'+index)"
                class="help is-danger"
              >{{ errors.first('dir-year_moved_to_address_'+index) }}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <p class="control">
            <label class="checkbox">
              <input
                v-validate="''"
                class="agreements"
                :class="{'is-danger': errors.has('include_account_in_bonus_program') }"
                name="tos_with_link"
                type="checkbox"
                :data-vv-as="translations.text.tos_with_link"
                v-model="body.tos_with_link"
              />
              <span class="checkmark"></span>
              <span v-html="translations.text.tos_with_link"></span>
            </label>
            <span
              v-show="errors.has('tos_with_link')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('tos_with_link') }}</span>
          </p>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <p class="control">
            <label class="checkbox">
              <input
                class="agreements"
                :class="{ 'is-danger': errors.has('agree_terms_marketing') }"
                name="agree_terms_marketing"
                type="checkbox"
                :data-vv-as="translations.text.agree_terms_marketing"
                v-model="body.agree_terms_marketing"
              />
              <span class="checkmark"></span>
              <!-- <span>{{ $t('agree_terms_marketing')}}</span> -->
              <span v-html="translations.text.agree_terms_marketing"></span>
            </label>
          </p>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <p
            class="control privacy_data_text"
            v-html="translations.text.data_policy_text"
          >
          </p>
        </div>
      </div>
      <a
        class="button is-dark is-pulled-left previous"
        @click="$bus.$emit('PreviousStep', $event)"
      >
        <span>{{$t("previous")}}</span>
      </a>
      <a
        class="button is-success is-pulled-right is-medium next"
        :class="[isDisabled? 'disabledButton':'']"
        @click="validateCaptcha"
        :disabled="isDisabled"
      >
        <span class="icon is-small">
          <i class="fa fa-check"></i>
        </span>
        <span>{{$t("complete")}}</span>
      </a>
    </div>
    <div
        v-if="showEUNoticeModal"
        class="modal small EUModal"
        :class="{ 'is-active': showEUNoticeModal }"
      >
        <div class="modal-background"></div>
        <div class="modal-card">
          <section class="modal-card-body">
            <div class="columns">
              <div class="column">
                <h2>{{ $t('important_information') }}</h2>
                <div class="control">
                  <p
                  >{{ $t('important_information_text') }}</p>
                </div>
              </div>
            </div>
            <a
              class="button"
              href="https://my.eurotrader.eu/en/register/partner"
            >{{ $t('continue').tTitle() }}</a>
          </section>
        </div>
      </div>
  </section>
</template>

<script>
// import axios from 'axios'
// import {service} from '../app'
import { mapGetters } from 'vuex'
import config from '../../config'
import moment from 'moment'

export default {
  props: ['translations', 'step', 'legalType', 'isLead'],
  data() {
    return {
      isDisabled: false,
      countries: config.countries,
      nationalities: config.nationalities,
      titles: config.titles,
      monthDayIndexes: Array.from({ length: 31 }, (v, i) => ++i),
      years: [],
      numberOfShareholders: 1,
      numberOfDirectors: 1,
      hiddenCountries: ['SY', 'IQ', 'AF', 'ER', 'LY', 'SS', 'KP', 'US', 'SD', 'RU', 'CA', 'SO', 'IR', 'TR', 'BE', 'JP', 'MM', 'YE', 'JM', 'HT', 'CD', 'BF', 'BB', 'AL', 'KY', 'ML', 'MZ', 'NG', 'PA', 'PH', 'SN', 'TZ', 'UG', 'CN'],
      body: {
        title: '',
        firstname: '',
        lastname: '',
        email: '',
        country: '',
        dialCode: '',
        nationality: '',
        phone: '',
        gender: '',
        address: '',
        address2: '',
        post_code: '',
        city: '',
        state_province: '',
        year_moved_to_address: '',
        website: '',
        skype_id: '',
        dateofbirth: '',
        dob: {
          day: null,
          month: null,
          year: null,
        },
        password: '',
        confirm_password: '',
        company_name: '',
        tos_with_link: false,
        agree_terms_marketing: false,
        shareholders: [this.emptyShareholderDirector()],
        directors: [this.emptyShareholderDirector()],
        ib_main_target_region: '',
        walletCurrency: 'usd',
        i_am_over_18: false,
        recaptchaToken: null
      },
      showEUNoticeModal: false,
      recaptcha: null
    }
  },
  computed: {
    filteredCountries() {
      for (var i in this.countries) {
        if (this.hiddenCountries.includes(i)) {
          delete this.countries[i]
        }
      }
      return this.countries
    },
    ...mapGetters({
      Language: 'language/code',
    }),
  },
  watch: {
    numberOfShareholders(s) {
      let cs = this.body.shareholders.length
      let sum = cs - s
      if (sum === 0) {
      } else if (sum < 0) {
        for (let i = sum; i < 0; i++) {
          this.body.shareholders.push(this.emptyShareholderDirector())
        }
      } else {
        this.body.shareholders.splice(-sum, sum)
      }
    },
    numberOfDirectors(s) {
      let cs = this.body.directors.length
      let sum = cs - s
      if (sum === 0) {
      } else if (sum < 0) {
        for (let i = sum; i < 0; i++) {
          this.body.directors.push(this.emptyShareholderDirector())
        }
      } else {
        this.body.directors.splice(-sum, sum)
      }
    },
    'body.country'(c) {
      this.body.dialCode = '+' + this.countries[c].dialCode
    },
  },
  mounted() {
    this.$bus.$emit('ChangeHeadings', this.$t('page_title_partner'), this.$t('partner_account'))
    let currentYear = moment().year()
    this.years = Array.from({ length: 100 }, (v, i) => currentYear - i)
    this.$bus.$on('isLead', this.handleLeadData)
  },
  beforeDestroy() {
    this.$bus.$off('isLead', this.handleLeadData)
  },
  methods: {
    validateCaptcha() {
      this.$recaptchaLoaded()
      this.recaptcha = this.$recaptcha('complete')

      var badge = document.getElementsByClassName('grecaptcha-badge')[0]
      badge.style.zIndex = '21'

      this.recaptcha.then(value => {
        this.complete(value)
      }).catch(err => {
        console.log(err)
      })
    },
    handleLeadData(e) {
      if (!e) {
        return
      }
      let required = ['title', 'firstname', 'lastname', 'email', 'country', 'phone']
      for (let v of required) {
        if (typeof this.$route.query[v] !== 'undefined' && typeof this.body[v] !== 'undefined') {
          this.body[v] = this.$route.query[v]
        }
      }
    },
    emptyShareholderDirector() {
      return {
        firstname: '',
        lastname: '',
        dateofbirth: '',
        dob: {
          day: -1,
          month: -1,
          year: -1,
        },
        country: '',
        address: '',
        address2: '',
        post_code: '',
        city: '',
        state_province: '',
        year_moved_to_address: -1,
      }
    },
    composeSpecialFields() {
      this.body.dateofbirth = this.body.dob.year + '-' + this.body.dob.month + '-' + this.body.dob.day
      this.body.year_moved_to_address = parseInt(this.body.year_moved_to_address)
      if (isNaN(this.body.year_moved_to_address)) {
        this.body.year_moved_to_address = ''
      }
      // handle Date of Birth
      if (this.legalType === 'company') {
        for (let i = 0, l = this.body.shareholders.length; i < l; i++) {
          this.body.shareholders[i].dateofbirth = this.body.shareholders[i].dob.year + '-' + this.body.shareholders[i].dob.month + '-' + this.body.shareholders[i].dob.day
          this.body.shareholders[i].year_moved_to_address = parseInt(this.body.shareholders[i].year_moved_to_address)
        }
        for (let i = 0, l = this.body.directors.length; i < l; i++) {
          this.body.directors[i].dateofbirth = this.body.directors[i].dob.year + '-' + this.body.directors[i].dob.month + '-' + this.body.directors[i].dob.day
          this.body.directors[i].year_moved_to_address = parseInt(this.body.directors[i].year_moved_to_address)
        }
      }
    },
    nextStep() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.composeSpecialFields()
          this.$bus.$emit('NextStep', this.body)
          return
        }
        // scroll to first message
        let el = document.getElementsByName(this.errors.errors[0].field)[0]
        el.focus()
      })
    },
    complete(token) {
      this.body.recaptchaToken = token

      this.$validator.validateAll().then(result => {
        if (result) {
          if (!this.body.tos_with_link) {
            this.$toasted.error(this.$t('must_agree_terms'))
            return
          }
          if (this.legalType == 'individual' && new Date().getFullYear() - this.body.dob.year < 18) {
            this.$toasted.error(this.$t('must_be_over_18'))
            return
          }

          if (this.legalType == 'company') {
            for (let i = 0, l = this.body.shareholders.length; i < l; i++) {
              if (new Date().getFullYear() - this.body.shareholders[i].dob.year < 18) {
                this.$toasted.error(this.$t('shareholders_must_be_over_18'))
                return
              }
            }
            for (let i = 0, l = this.body.directors.length; i < l; i++) {
              if (new Date().getFullYear() - this.body.directors[i].dob.year < 18) {
                this.$toasted.error(this.$t('directors_must_be_over_18'))
                return
              }
            }
          }
          this.composeSpecialFields()
          this.isDisabled = true
          this.$bus.$emit('Complete', this.body)
        }
      })
    },
    checkIfIsEuropeanCountry() {
      if (config.EUCountries.includes(this.body.country)) {
        this.showEUNoticeModal = true
        return
      }
      this.showEUNoticeModal = false
    }
  },
}
</script>

<style lang="scss">
@import '../../assets/css/variables';

.partner .step {
  margin-left: 4%;
}

.partner .progressNum {
  margin-bottom: 78px;
}

.partner .progressNum > ul {
  display: table;
  margin: 0 auto;
}
.partner .progressNum > ul li {
  width: auto;
  font: normal normal 900 47px/53px Roboto;
  letter-spacing: -0.94px;
  color: #fff;
  @media screen and (max-width: $mobile) {
    font-size: 20px;
  }
  span {
    font-size: 16px;
    line-height: 34px;
    letter-spacing: -0.32px;
    color: #b591fb;
    margin-top: 10px;
    display: table;
    text-transform: capitalize;
  }
  &::before {
    width: 78px;
    height: 78px;
    border: 0;
    line-height: 78px;
    background-color: #b591fb;
    @media screen and (max-width: $mobile) {
      width: 40px;
      height: 40px;
      line-height: 40px;
    }
  }
}

.partner .progressNum > ul li.active {
  color: #fff;
  font-weight: 900;
  span {
    color: #6826f4;
  }
  &::before {
    background-color: #6826f4;
  }
}

.partner span.step_divider {
  height: 2px;
  width: 192px;
  background-color: #b591fb;
  float: left;
  margin-top: 10%;
  margin-left: 25px;
  margin-right: 25px;
  @media screen and (max-width: $mobile) {
    width: 50px;
    margin-top: 11%;
    margin-left: 15px;
    margin-right: 15px;
  }
}

.partner .step > h2 {
  font: normal normal 900 30px/34px Roboto;
  letter-spacing: -0.6px;
  text-transform: capitalize;
  border: 0;
}

.partner .previous {
  width: 152px;
  height: 40px;
  background-color: #7b7c7e;
  border-radius: 23px;
  font: normal normal 500 12px/14px Roboto;
  letter-spacing: 0px;
  margin-top: 54px;
  transition: all 0.3s ease-in-out;
  @media screen and (max-width: $mobile) {
    margin-bottom: 55px;
  }
}

.partner .next {
  width: 152px;
  height: 40px;
  background-color: #6826f4;
  border-radius: 23px;
  font: normal normal 500 12px/14px Roboto;
  letter-spacing: 0px;
  margin-top: 54px;
  transition: all 0.3s ease-in-out;
  @media screen and (max-width: $mobile) {
    margin-bottom: 55px;
  }
}

@media screen and (max-width: $mobile) {
  .partner .columns {
    margin: 0;
  }
}

.step input.push-left {
  padding-left: 63px;
}

.dialcodeBox {
  position: absolute;
  left: 11px;
  top: 9px;
  z-index: 1;
  color: #10182a;
  font: normal normal 300 18px/28px Roboto;
}

.modal.EUModal {
    h2{
      font: normal normal 900 30px/34px Roboto;
      color: #10182a;
      margin-bottom: 30px;
      text-align: left;
      border:0;
      @media only screen and (max-width: 768px) {
          font-size: 25px;
      }
    }
    .modal-card{
      padding: 40px;
      background: #fff;
      border-bottom-right-radius: 30px;
      @media only screen and (max-width: 768px) {
          padding: 0;
      }
      .modal-card-body{
        @media only screen and (max-width: 768px) {
          padding-top: 30px;
          padding-bottom: 40px;
        }
      }
      p{
        text-align: left;
        font: normal normal 300 16px/24px Roboto;
        letter-spacing: 0px;
        color: #10182a;
      }
    }
    .button{
        width: 220px;
        height: 47px;
        background-color: #6826f4;
        border-radius: 23px;
        font: normal normal 400 14px/14px Roboto;
        letter-spacing: 0px;
        margin-top: 20px;
        color: #fff;
        transition: all 0.3s ease-in-out;
    }
}
</style>



// WEBPACK FOOTER //
// Partner.vue?e6b77442